<template>
    <div class="pt-3">
        <div class="dashboard-table">
            <b-row class="table-header font-weight-bold">
                <b-col cols="3">Cliente</b-col>
                <b-col cols="4">Puesto</b-col>
                <b-col cols="1">Problemas</b-col>
                <b-col cols="2">Porcentaje</b-col>
                <b-col cols="2">Acumulado</b-col>
            </b-row>
            <b-row
                v-for="(indicator, i) in indicators"
                :key="i"
                class="table-row"
                :class="{ 'pareto-highlight': indicator.accumulated <= 80 }"
                style="cursor: pointer"
                @click="goToChecklist(indicator)"
            >
                <b-col cols="3">{{ indicator.client_name }}</b-col>
                <b-col cols="4">{{ indicator.venue_name }}</b-col>
                <b-col cols="1">{{ indicator.issues }}</b-col>
                <b-col cols="2">{{ indicator.percentage }}%</b-col>
                <b-col cols="2">{{ indicator.accumulated.toFixed(2) }}%</b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        year: {
            type: [Number, String],
            default: () => new Date().getFullYear(),
        },
        month: {
            type: [Number, String],
            default: () => new Date().getMonth() + 1,
        },
    },
    data: () => ({
        indicators: [],
    }),
    watch: {
        year() {
            this.loadIndicators()
        },
        month() {
            this.loadIndicators()
        },
    },
    computed: {
        totalIssues() {
            return this.indicators.reduce((acc, item) => {
                return acc + item.issues
            }, 0)
        },
    },
    methods: {
        async loadIndicators() {
            try {
                console.log('Loading indicators')
                let params = {
                    year: this.year,
                    month: this.month,
                }

                const { data } = await this.$repo.get(
                    'dashboards/supervisors/checklists-items-by-venue-indicators',
                    params
                )

                const totalIssues = data.reduce((acc, item) => {
                    return acc + item.issues
                }, 0)

                let accum = 0
                const indicators = data
                    .sort((a, b) => b.issues - a.issues)
                    .map((item) => ({
                        ...item,
                        percentage: !!totalIssues
                            ? ((item.issues / totalIssues) * 100).toFixed(2)
                            : 0,
                        accumulated: (accum += !!totalIssues
                            ? (item.issues / totalIssues) * 100
                            : 0),
                    }))

                this.indicators = indicators
            } catch (error) {
                toastr.error(
                    'Error al cargar los indicadores de los items de la lista de chequeo'
                )
            }
        },
        async loadVenues() {
            const { data } = await this.$repo.get('venues', {
                with: 'client:id,name;city:id,name',
            })
            this.venues = data.map((venue) => ({
                ...venue,
                name:
                    (venue.client?.name ?? '') +
                    ' - ' +
                    venue.name +
                    ' - ' +
                    (venue.city?.name ?? ''),
            }))
        },
        goToChecklist(indicator) {
            this.$emit('show-venue', indicator)
        },
    },
    mounted() {
        this.loadIndicators()
        this.loadVenues()
        // await this.updateChart()
    },
}
</script>
<style scoped>
.dashboard-table {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    overflow: hidden;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.table-header {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    padding: 0.75rem;
}

.table-row {
    border-bottom: 1px solid #dee2e6;
    padding: 0.75rem;
    transition: background-color 0.3s ease;
}

.table-row:last-child {
    border-bottom: none;
}

.table-row:hover {
    background-color: #f8f9fa;
}

.pareto-highlight {
    background-color: #ffebee;
    color: #d32f2f;
}

.pareto-highlight:hover {
    background-color: #ffcdd2;
}
</style>
